import api from '../../../services/api';
import {
  setSkuItems,
  setFilteredSkuItems,
  setLoading,
  setError,
  setPagination,
  setFilters
} from '../reducers';

// Hàm lấy danh sách các SKU Items từ API với phân trang
export const fetchSkuItems = (page = 1, pageSize = 10) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    // Lấy thông tin filter hiện tại
    const { filters } = getState().skuItems;

    // Tạo query params cho API request
    const queryParams = new URLSearchParams();
    queryParams.append('page', page);
    queryParams.append('pageSize', pageSize);

    // Thêm các filter vào query params nếu có
    if (filters.searchText) {
      // Gửi một tham số search thống nhất thay vì ba tham số riêng biệt
      queryParams.append('searchText', filters.searchText);
    }

    if (filters.selectedFulfillmentChannel && filters.selectedFulfillmentChannel !== 'all') {
      queryParams.append('fulfillmentChannel', filters.selectedFulfillmentChannel);
    }

    if (filters.selectedStatus && filters.selectedStatus !== 'all') {
      queryParams.append('status', filters.selectedStatus);
    }

    if (filters.selectedSellerAccount && filters.selectedSellerAccount !== 'all') {
      queryParams.append('sellerAccountId', filters.selectedSellerAccount);
    }

    // Gọi API với các tham số phân trang và lọc
    const response = await api.get(`/inventory/skuItems?${queryParams.toString()}`);
    
    // Xử lý kết quả trả về
    if (response.data) {
      dispatch(setSkuItems(response.data.rows));
      dispatch(setPagination({
        current: response.data.pagination.page,
        pageSize: response.data.pagination.pageSize,
        total: response.data.pagination.total
      }));
    }
  } catch (error) {
    console.error('Error fetching SKU items:', error);
    dispatch(setError('Không thể lấy danh sách các SKU items'));
  } finally {
    dispatch(setLoading(false));
  }
};

// Hàm áp dụng bộ lọc cho SKU Items và tải lại dữ liệu
export const applyFilters = (searchText, selectedFulfillmentChannel, selectedStatus, selectedSellerAccount) => (dispatch, getState) => {
  // Lưu các filter mới
  dispatch(setFilters({ searchText, selectedFulfillmentChannel, selectedStatus, selectedSellerAccount }));
  
  // Tải lại dữ liệu với filter mới và reset về trang đầu tiên
  dispatch(fetchSkuItems(1, getState().skuItems.pagination.pageSize));
};

// Hàm xử lý khi thay đổi trang hoặc kích thước trang
export const onChangePagination = (page, pageSize) => (dispatch) => {
  dispatch(fetchSkuItems(page, pageSize));
};

// Hàm xem chi tiết SKU Item
export const viewSkuItemDetail = (id, navigate) => () => {
  navigate(`/inventory/sku-items/${id}`);
};

// Hàm chỉnh sửa SKU Item
export const editSkuItem = (id, navigate) => () => {
  navigate(`/inventory/sku-items/${id}/edit`);
};

// Hàm xóa SKU Item
export const deleteSkuItem = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/inventory/skuItems/${id}`);
    // Tải lại dữ liệu sau khi xóa
    dispatch(fetchSkuItems(
      getState().skuItems.pagination.current,
      getState().skuItems.pagination.pageSize
    ));
    return { success: true, message: 'SKU Item đã được xóa thành công' };
  } catch (error) {
    return { success: false, message: 'Lỗi khi xóa SKU Item' };
  }
};

// Hàm đồng bộ SKU Items từ Amazon
export const syncAmazonSkuItems = (submitData) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    await api.post('/inventory/skuItems/sync', submitData);
    // Tải lại danh sách sau khi đồng bộ
    dispatch(fetchSkuItems(1));
    return { success: true, message: 'Đồng bộ SKU Items từ Amazon thành công!' };
  } catch (error) {
    console.error('Error syncing SKU items:', error);
    dispatch(setError('Không thể đồng bộ SKU Items từ Amazon'));
    return { success: false, message: 'Lỗi khi đồng bộ SKU Items' };
  } finally {
    dispatch(setLoading(false));
  }
};

// Cập nhật trạng thái của SKU Item
export const updateSkuItemStatus = (id, status) => async (dispatch, getState) => {
  try {
    await api.put(`/inventory/skuItems/${id}`, { status });
    // Tải lại dữ liệu sau khi cập nhật
    dispatch(fetchSkuItems(
      getState().skuItems.pagination.current,
      getState().skuItems.pagination.pageSize
    ));
    return { success: true, message: 'Trạng thái SKU Item đã được cập nhật thành công' };
  } catch (error) {
    return { success: false, message: 'Lỗi khi cập nhật trạng thái SKU Item' };
  }
};